const getLastIntervalEndTime = (interval) => {
  return new Date().getTime() - getIntervalTime(interval);
};

const getIntervalTime = (interval) => {
  if (interval === '1d') {
    return 24 * 3600 * 1000;
  }

  if (interval === '12h') {
    return 12 * 3600 * 1000;
  }

  if (interval === '6h') {
    return 6 * 3600 * 1000;
  }

  throw new Error(`unexpect interval ${interval}`);
};

export {
  getLastIntervalEndTime,
  getIntervalTime,
};
